import { isFunction } from 'lodash-es';
import { ReactElement, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { Container, createRoot } from 'react-dom/client';

// Only activate the React 18 rendering engine in non-client environments.
// Allow local, dev, test, PR previews, and CI tests.
// const render18 = IS_NOT_PREVIEW_OR_PROD;

// Only allow in local and dev environments. Not in Test, CI, or client environments.
// const render18 = IS_LOCAL_DEV || IS_DEV_DOMAIN;

// Do not use React 18 engine anywhere by default. May change this later when we're ready to
// start rolling it out. See above options.
const render18 = false;

/**
 * Render the root element of the application. By default will use the old React 17 render engine.
 * To turn it on for a specific app, pass `force18 = true` in the second argument.
 */
export const renderRoot = (node: ReactElement, force18 = false): void => {
  const rootEl = document.getElementById('root');
  if (force18 || render18) {
    // Render with React 18 if the app requests it, or if we decide to render it in specific domains.
    const root = createRoot(rootEl as Container);
    root.render(node);
  } else {
    // Render with React 17.
    ReactDOM.render(node, rootEl);
  }
};

/** Renders a label. React 18+ no longer allows rendering a function directly. Must evaluate before passing to JSX. */
export const renderLabel = (
  label?: string | ((item?: Maybe<fixMe>) => ReactNode),
): ReactNode => {
  return isFunction(label) ? label() : (label ?? '');
};

/** Renders a title. React 18+ no longer allows rendering a function directly. Must evaluate before passing to JSX. */
export const renderTitle = (
  title?: ReactNode | (() => ReactNode),
): ReactNode => {
  return isFunction(title) ? title() : (title ?? '');
};
